import { IUpdateHospitalAction } from './updateHospital.interface';

export enum UpdateHospitalTypes {
	UPDATE_HOSPITAL = 'UPDATE_HOSPITAL',
}

export type UpdateHospitalAction = IUpdateHospitalAction;
